export function parsePromotionTerms(searchTerms) {
    return String(searchTerms || '')
        .split(/\r?\n/g)
        .map((term) => term.trim().toLowerCase())
        .filter(Boolean);
}

export function normalizeQuery(value) {
    return String(value || '')
        .trim()
        .toLowerCase();
}

export function getPromotionForQuery(queryValue, promotions) {
    if (!promotions || !Array.isArray(promotions)) return null;

    const query = normalizeQuery(queryValue);
    const activePromotions = promotions.filter(
        (promo) => promo && promo.active_now && promo.is_active === 'yes'
    );
    if (!activePromotions.length) return null;

    if (query.length > 0) {
        for (const promo of activePromotions) {
            const terms = parsePromotionTerms(promo.search_terms);
            const hasMatch = terms.some(
                (term) => query.includes(term) || (query.length >= 3 && term.includes(query))
            );

            if (hasMatch) {
                return promo;
            }
        }
    }

    return activePromotions.find((promo) => promo.is_default === 'yes') || null;
}

export function renderPromotion(bannerContainer, promotion) {
    if (!bannerContainer) return;

    const currentSignature = promotion
        ? JSON.stringify({
              id: promotion.name || '',
              desktop: promotion.desktop_image || '',
              mobile: promotion.mobile_image || '',
              link: promotion.target_link || '',
              tab: promotion.open_new_tab || 'no',
          })
        : '';

    if (bannerContainer.dataset.promoSignature === currentSignature) {
        return;
    }
    bannerContainer.dataset.promoSignature = currentSignature;

    if (!promotion) {
        bannerContainer.innerHTML = '';
        bannerContainer.classList.remove('is-visible');
        return;
    }

    const desktopImage = String(promotion.desktop_image || '').trim();
    const mobileImage = String(promotion.mobile_image || '').trim();
    const fallbackImage = desktopImage || mobileImage;
    if (!fallbackImage) {
        bannerContainer.innerHTML = '';
        bannerContainer.classList.remove('is-visible');
        return;
    }

    const pictureHtml = `
        <picture>
            ${mobileImage ? `<source media="(max-width: 768px)" srcset="${mobileImage}">` : ''}
            <img src="${fallbackImage}" alt="Promotion banner" loading="lazy">
        </picture>
    `;

    const href = String(promotion.target_link || '').trim();
    const openInNewTab = promotion.open_new_tab === 'yes';
    const targetAttrs = openInNewTab ? ' target="_blank" rel="noopener noreferrer"' : '';

    bannerContainer.innerHTML = href
        ? `<a class="snaf-promo-banner__link" href="${href}"${targetAttrs}>${pictureHtml}</a>`
        : `<div class="snaf-promo-banner__media">${pictureHtml}</div>`;

    bannerContainer.classList.add('is-visible');
}
